export enum BusniessOfficeReportType {
  POST = "post",
  PRE = "pre",
  VISIT = "visit",
  FINAL = "final",
}
